import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { StockCrudService } from 'src/app/shared/services/stock-crud.service';
import { Unit } from 'src/app/shared/interfaces/unit';
import { UnitCrudService } from 'src/app/shared/services/unit-crud.service';
import { ContentType } from 'src/app/shared/interfaces/content-type';
import { PackagingType } from 'src/app/shared/interfaces/packaging-type';
import { ContentTypeCrudService } from 'src/app/shared/services/content-type-crud.service';
import { PackagingTypeCrudService } from 'src/app/shared/services/packaging-type-crud.service';
import { ProductCrudService } from 'src/app/shared/services/product-crud.service';
import { Product } from 'src/app/shared/interfaces/product';
import { Stock } from 'src/app/shared/interfaces/stock';


@Component({
  selector: 'app-stock',
  templateUrl: './stock.component.html',
  styleUrls: ['./stock.component.scss']
})
export class StockComponent implements OnInit {

  productTypes: Stock[];
  productType: Stock;
  selectedStocks: Stock[] = [];

  stockDialog: boolean = false;

  products: Product[] = [];
  product: Product = {} as Product;
  selectedProducts: Product[] = [];

  submitted: boolean = false;

  stocks : Stock[] = [];
  stock: Stock = {} as Stock;
  stockQuantityMap = new Map<string, number>();
  stockProductsMap = new Map<string, Product[]>();

  units: Unit[] = [];
  contentTypes: ContentType[] = [];
  packagingTypes: PackagingType[] = [];

  minActivityValues: number[] = [0, 1000];
  maxActivityValues: number[] = [0, 1000];

  contentTypeMap = new Map<string, ContentType>();
  packagingTypeMap = new Map<string, PackagingType>();

  dialogSelectContentKey : string = "";
  dialogSelectPackagingKey : string = "";

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  constructor(
   // private api: APIService,
    private productTypeService : StockCrudService,
    // private unitService : UnitCrudService,
    private productService : ProductCrudService,
    private contentTypeService : ContentTypeCrudService,
    private packagingTypeService : PackagingTypeCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Stock or inventory'}
    ];

    this.productTypes = [];
    this.productType = { } as Stock ;
    //this.getAllRecords();

    // productService.addProduct( {name: 'a'} );
    // productService.addProduct( {name: 'a'} );
    // productService.addProduct( {name: 'd'} );
    // productService.addProduct( {name: 'a'} );
    // productService.addProduct( {name: 'b'} );
    // productService.addProduct( {name: 'a'} );
    // productService.addProduct( {name: 'd'} );
    // productService.addProduct( {name: 'd'} );
    // productService.addProduct( {name: 'a'} );
  }

  ngOnInit(): void {
    
    this.dataState();
    // let s = this.productTypeService.GetStocksList(); 
    // s.snapshotChanges().subscribe(data => {
    //   this.productTypes = [];
    //   data.forEach(item => {
    //     let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
    //     if (jsonItem) {
    //       if (jsonItem) {
    //         jsonItem['$key'] = item.key;
    //       }
    //       this.productTypes.push(jsonItem as Stock);
    //     }
    //   })
    // });

    let p = this.productService.getProductsList(); 
    p.snapshotChanges().subscribe(data => {
      this.products = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.products.push(jsonItem as Product);
        }
      });
      this.refreshStocks(this.products);
    });

    

    // let u = this.unitService.GetUnitsList(); 
    // u.snapshotChanges().subscribe(data => {
    //   this.units = [];
    //   data.forEach(item => {
    //     let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
    //     if (jsonItem) {
    //       if (jsonItem) {
    //         jsonItem['$key'] = item.key;
    //       }
    //       this.units.push(jsonItem as unknown as Unit);
    //     }
    //   })
    // });

    let ct = this.contentTypeService.GetContentTypesList(); 
    ct.snapshotChanges().subscribe(data => {
      this.contentTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.contentTypes.push(jsonItem as unknown as ContentType);
          const content = jsonItem as unknown as ContentType;
          this.contentTypeMap.set( content.$key , content );
        }
      })
    });

    let pt = this.packagingTypeService.GetPackagingTypesList(); 
    pt.snapshotChanges().subscribe(data => {
      this.packagingTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.packagingTypes.push(jsonItem as unknown as PackagingType);
          const packaging = jsonItem as unknown as PackagingType;
          this.packagingTypeMap.set( packaging.$key , packaging );
        }
      })
    });

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'productTypeName', header: 'Product type' },
      { field: 'quantity', header: 'Quantity' },
      { field: 'products', header: 'Products' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    this._selectedColumns = this.cols;

    // Exports
    this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
  }

  refreshStocks(products: Product[]) {
    this.stocks = [];
    this.stockQuantityMap = new Map<string, number>();
    this.stockProductsMap = new Map<string, Product[]>();
    products.forEach( product => {
      const productName = product.label;
      if (!productName) {
        console.error(product);
      } else {
        if ( !this.stockQuantityMap.has(productName) ) {
          this.stockQuantityMap.set(productName, 0);
        } 
        let quantity : number = this.stockQuantityMap.get(productName) as number;
        this.stockQuantityMap.set(productName, (quantity + 1));
      }

      if (!productName) {
        console.error(product);
      } else {
        if ( !this.stockProductsMap.has(productName) ) {
          this.stockProductsMap.set(productName, []);
        } 
        let ps : Product[]  = this.stockProductsMap.get(productName) as Product[];
        ps.push(product);
        this.stockProductsMap.set(productName, ps);
      }
      
    });
    for ( const [key, value] of this.stockQuantityMap ) {
      this.stocks.push( { quantity: value, productTypeName: key , products: this.stockProductsMap.get(key) }  ); 
    }
  }

  dataState() {     
    this.productService.getProductsList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.Stocks);
            doc.save('content-types.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.productTypes);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "content-types");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    //this.exportService.exportToCsv(this.productTypes, 'Stocks', ['companyId', 'companyName', '$key', 'actions']);
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => exportCols.push(sc.field));
    this.exportService.exportToCsv(this.selectedStocks, 'content-types', exportCols);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.productType = {} as Stock;
    this.submitted = false;
    this.stockDialog = true;
    this.dialogSelectContentKey = "";
    this.dialogSelectPackagingKey = "";
  }

  deleteSelectedStocks() {
  //   this.confirmationService.confirm({
  //       message: 'Are you sure you want to delete the selected Packaging Types?',
  //       header: 'Confirm',
  //       icon: 'pi pi-exclamation-triangle',
  //       accept: () => {
  //         this.productTypes = this.productTypes.filter(val => !this.selectedStocks.includes(val));
  //         this.productTypes.forEach( pallet => {
  //           this.productTypeService.DeleteStock(pallet.$key);
  //         } );
          
  //         this.selectedStocks = [];
  //         this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging types deleted', life: 3000});
  //     }
  // });
  }

  editStock(productType: Stock) {
    this.productType = {...productType};
    this.stockDialog = true;
  }

  deleteStock(productType: Stock) {
    // this.confirmationService.confirm({
    //     message: 'Are you sure you want to delete ' + productType.name + '?',
    //     header: 'Confirm',
    //     icon: 'pi pi-exclamation-triangle',
    //     accept: () => {
    //         this.productTypes = this.productTypes.filter(val => val.$key !== productType.$key);
    //         this.productType = {} as Stock;
    //         this.productTypeService.DeleteStock(productType.$key);
    //         this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging Type Deleted', life: 3000});
    //     }
    // });
  }

  hideDialog() {
    this.stockDialog = false;
    this.submitted = false;
  }

  saveStock() {
    // this.submitted = true;
    // if (this.productType.$key) {
    //   this.productTypes[this.findIndexById(this.productType.$key)] = this.productType;                
    //   this.productTypeService.UpdateStock(this.productType);
    //   this.messageService.add({severity:'success', summary: 'Successful', detail: 'Packaging Type Updated', life: 3000});
    // } else {
    //   // this.pallet.id = this.createId();
    //   // this.pallet.image = 'product-placeholder.svg';

    //   if ( this.packagingTypeMap.has( this.dialogSelectPackagingKey ) ) {
    //     const packaging = this.packagingTypeMap.get( this.dialogSelectPackagingKey );
    //     if (packaging) {
    //       this.productType.container = packaging ;
    //       if (this.productType.container.$key) {
    //         delete this.productType.container.$key
    //         delete this.productType.container.isEnabled
    //       }
    //     }
    //   }

    //   if ( this.contentTypeMap.has( this.dialogSelectContentKey ) ) {
    //     const content = this.contentTypeMap.get( this.dialogSelectContentKey );
    //     if (content) {
    //       this.productType.content = content;
    //       if (this.productType.content.$key) {
    //         delete this.productType.content.$key
    //         delete this.productType.content.isEnabled
    //       }
    //     }
    //   }
      
      
    //   // dialogSelectContentKey = "";
    //   //  = "";)

    //   this.productTypeService.AddStock(this.productType);
    //   this.messageService.add({severity:'success', summary: 'Successful', detail: 'Product Type Created', life: 3000});
    //   this.productTypes = [...this.productTypes];
    // }
    // this.stockDialog = false;
    // this.productType = { } as Stock;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.productTypes.length; i++) {
        if (this.productTypes[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeStock(productType : Stock) {
    // const productTypeTmp = {
    //   ...productType
    // };
    // console.log("SAVE", productTypeTmp);
    // this.productTypeService.UpdateStock(  productTypeTmp );
  }

}
